module.exports = __webpack_public_path__ + "img/lantern2.b3efb04e.png";